// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular.json`.

export const environment = {
  production: false,
  // baseURL : 'http://161.117.176.141/api/v1/'
 // baseURL : 'http://161.117.231.37/api/v1/'
 baseURL : 'https://api.cycloan.io/api/v1/'
 //baseURL : 'http://localhost:3001/api/v1/'

 // baseURL : 'https://api.cycloan.io/api/v1/'


};
